import { Snakelize } from "@shared/entities";

export const serializeSnakeToCamel = <T>(obj: any): T => {
    if (obj === null || obj === undefined) {
      return obj;
    }
  
    if (Array.isArray(obj)) {
      return obj.map(serializeSnakeToCamel) as unknown as T;
    }
  
    if (typeof obj === "object") {
      return Object.keys(obj).reduce(
        (result: { [key: string]: unknown }, key) => {
          const camelKey = key.replace(/_\w/g, (m) => m[1].toUpperCase());
          const camelValue = serializeSnakeToCamel(obj[key]);
          result[camelKey] = camelValue;
          return result;
        },
        {}
      ) as T;
    }
  
    return obj;
  };


export function serializeCamelToSnake<S>(obj: S): Snakelize<S> {
    if (obj === null || obj === undefined) {
      return obj as Snakelize<S>;
    }
  
    if (Array.isArray(obj)) {
      return obj.map(serializeCamelToSnake) as unknown as Snakelize<S>;
    }
  
    if (typeof obj === "object" && obj !== null) {
      const result = Object.keys(obj).reduce(
        (result: { [key: string]: unknown }, key) => {
          const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
          const snakeValue = serializeCamelToSnake((obj as any)[key]);
          result[snakeKey] = snakeValue;
          return result;
        },
        {}
      );
      return result as Snakelize<S>;
    }
  
    return obj as Snakelize<S>;
  }